import { UserRolesTypes } from '../../models';
import { usePermissions } from './usePermissions';

export const useUserHasRoles = (...roles: UserRolesTypes[]): boolean => {
  const { canRender } = usePermissions();

  return canRender(roles);
};
